module.exports = __webpack_public_path__ + "static/media/points10_2.bbc8b89a.png";